export const isOnAutosignoutPage = (): boolean =>
  !!window && !!window.location && !!window.location.href && window.location.href.indexOf('autosignout=1') !== -1;
